// 'use client';

// Third-party Imports
import classnames from 'classnames';

// Type Imports
import type { ChildrenType } from '../../../@core/types';

// Hook Imports
import { useSettings } from '../../../@core/hooks/useSettings';

// Util Imports
import { verticalLayoutClasses } from '../../utils/layoutClasses';

import { useGlobalStore } from '@ice-web-app/shared-store';
import { ReactElement, cloneElement } from 'react';
// Styled Component Imports
import StyledMain from '../../styles/shared/StyledMain';

const LayoutContent = ({ children }: ChildrenType) => {
  // Hooks
  const { settings } = useSettings();
  const { contentPadding } = useGlobalStore();

  // Vars
  const contentCompact = settings.contentWidth === 'compact';
  const contentWide = settings.contentWidth === 'wide';

  const responsiveLayoutPadding = contentPadding
    ? typeof contentPadding === 'number'
      ? `p-[${contentPadding}px]`
      : `p-[${contentPadding.xs}px] sm:p-[${contentPadding.sm}px] md:p-[${contentPadding.md}px] lg:p-[${contentPadding.lg}px] xl:p-[${contentPadding.xl}px]`
    : contentPadding === 0
      ? ''
      : 'p-[10px] sm:p-[20px] md:p-[30px] lg:p-[24px] xl:p-[24px]';

  return (
    <StyledMain
      isContentCompact={contentCompact}
      className={classnames(
        verticalLayoutClasses.content,
        'flex-auto',
        {
          [`${verticalLayoutClasses.contentCompact} is-full`]: contentCompact,
          [verticalLayoutClasses.contentWide]: contentWide,
        },
        responsiveLayoutPadding,
      )}
      // style={{ minHeight: `calc(100vh - ${portalHeaderHeight}px)` }}
      // style={{ minHeight: `100vh` }}
    >
      {children}
    </StyledMain>
  );
};

export default LayoutContent;
